<p-dialog
  header="Hide Job?"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  (onShow)="onShow()"
  [style]="{ width: '400px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    Select a reason for hiding this
    {{ job ? (job.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2') : '' }} job
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>

  <div class="ui-grid-row">
    <div style="clear: both"></div>

    <div *ngFor="let reason of hideReasons" class="reject-reason">
      <p-radioButton
        [name]="reason.reason"
        [id]="reason.id"
        [label]="reason.reason"
        [value]="reason"
        [(ngModel)]="hideReason"
      ></p-radioButton>
    </div>
    <div *ngIf="hideReason?.requireText">
      <textarea
        pInputTextarea
        [(ngModel)]="hideText"
        style="width: 100%; height: 150px"
        placeholder="Please specify other reason*"
      ></textarea>
    </div>
  </div>

  <div
    class="style2023"
    style="
      display: flex;
      margin-top: 20px;
      width: 100%;
      grid-gap: 15px;
      justify-content: space-evenly;
      align-items: center;
      flex-direction: row;
      flex-wrap: nowrap;
    "
  >
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      class="button-style ui-tertiary-button"
      label="No, cancel"
      (click)="visibleChange.emit(false)"
      style="width: 100%"
    ></button>

    <button
      type="button"
      [disabled]="hideReason == null || (hideReason?.requireText && !hideText)"
      class="button-style ui-primary-button"
      pButton
      icon="fa ui-icon-trash"
      (click)="rejectJob()"
      label="Yes, hide job"
      style="width: 100%"
    ></button>
  </div>
</p-dialog>
